"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/web.dom.iterable");
var _goods_activity_combo = require("@/api/goods_activity/goods_activity_combo");
var _booking = require("@/api/goods_activity/booking.js");
var _shopList = require("@/api/shop/shopList");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'BookingConfigPane',
  components: {},
  props: {
    bookingList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      fnId: '',
      form: {
        activityName: '',
        // 活动名称
        storeIds: [],
        // 门店ID集合
        bookingDateList: [],
        // 预定日期
        diningDateList: [],
        // 就餐日期
        lunchQty: 1,
        // 午餐数量 - 库存
        dinnerQty: 1,
        // 晚餐数量 - 库存
        checkedGoodsList: [],
        // 关联商品
        markForEnable: true // 是否启用
      },
      goodsTableKey: 0,
      // 商品表格的key
      searchGoodsLoading: false,
      // 商品搜索加载中
      goodsList: [],
      // 商品列表
      checkedGoods: {},
      // 选中的商品

      // 门店选择相关
      storeSearchText: '',
      // 门店搜索文本
      storeTreeData: [],
      // 门店树形数据
      defaultProps: {
        // 树形控件属性
        children: 'children',
        label: 'label'
      },
      expandedKeys: [1, 2],
      // 默认展开的节点
      checkedKeys: [],
      // 默认选中的节点
      checkedLeafKeys: [],
      // 选中的叶子节点（门店）
      selectedStores: [],
      // 已选择的门店列表

      isEditMode: false,
      // 是否为编辑模式
      isInitializing: true // 是否正在初始化
    };
  },
  computed: {
    // 计算属性：根据模式决定显示哪些门店
    displayedStores: function displayedStores() {
      if (this.isEditMode) {
        // 编辑模式下显示传入的门店列表
        return this.bookingList;
      } else {
        // 批量设置模式下显示右侧选择的门店
        // 如果selectedStores有内容（用户选择或从外部传入的门店已加载），则显示selectedStores
        if (this.selectedStores.length > 0) {
          return this.selectedStores;
        }
        // 否则返回传入的bookingList作为初始值
        return this.bookingList;
      }
    },
    // 计算属性：判断是否全选
    isAllSelected: function isAllSelected() {
      // 获取所有叶子节点的数量
      var _getAllLeafCount = function getAllLeafCount(nodes) {
        var count = 0;
        nodes.forEach(function (node) {
          if (node.children && node.children.length > 0) {
            count += _getAllLeafCount(node.children);
          } else {
            count++;
          }
        });
        return count;
      };
      var totalLeafCount = _getAllLeafCount(this.storeTreeData);
      return totalLeafCount > 0 && this.checkedLeafKeys.length === totalLeafCount;
    }
  },
  watch: {
    storeSearchText: function storeSearchText(val) {
      this.$refs.storeTree.filter(val);
    }
  },
  created: function created() {
    var _this = this;
    // 设置初始化标志
    this.isInitializing = true;

    // 获取门店树形数据
    this.getStoreTreeData().then(function () {
      // 如果传入了门店列表
      if (_this.bookingList.length > 0) {
        // 检查是否有fnId来判断是否为编辑模式
        var hasFnId = _this.bookingList.some(function (item) {
          return item.fnId;
        });
        if (_this.bookingList.length === 1 && hasFnId) {
          // 单个门店编辑模式
          _this.isEditMode = true;
          _this.selectedStores = (0, _toConsumableArray2.default)(_this.bookingList);
          _this.checkedLeafKeys = _this.bookingList.map(function (item) {
            return item.storeId || item.id;
          });
          var booking = _this.bookingList[0];
          _this.fnId = booking.fnId;
          if (_this.fnId) {
            _this.querygetBookingDetail(_this.fnId);
          }
        } else {
          // 批量设置模式，但传入了门店列表（例如用户从外部选择了多个门店）
          _this.isEditMode = false;
          _this.selectedStores = (0, _toConsumableArray2.default)(_this.bookingList);
          _this.checkedLeafKeys = _this.bookingList.map(function (item) {
            return item.storeId || item.id;
          });
        }

        // 设置右侧树形控件的默认选中状态
        _this.$nextTick(function () {
          _this.$refs.storeTree && _this.$refs.storeTree.setCheckedKeys(_this.checkedLeafKeys);
          // 设置完成后，取消初始化标志
          _this.isInitializing = false;
        });
      } else {
        // 没有传入门店列表，也需要取消初始化标志
        _this.isInitializing = false;
      }
    }).catch(function () {
      // 出错时也要取消初始化标志
      _this.isInitializing = false;
    });
  },
  methods: {
    // 获取门店树形数据
    getStoreTreeData: function getStoreTreeData() {
      var _this2 = this;
      return (0, _shopList.queryStore)({}).then(function (res) {
        _this2.storeTreeData = res.data;
        return res;
      });
    },
    querygetBookingDetail: function querygetBookingDetail(fnId) {
      var _this3 = this;
      (0, _booking.getBookingDetail)(fnId).then(function (res) {
        var data = res.data;
        if (data) {
          _this3.form.activityName = data.gaBooking.activityName;
          _this3.form.lunchQty = data.gaBooking.lunchQty;
          _this3.form.dinnerQty = data.gaBooking.dinnerQty;
          _this3.form.markForEnable = data.gaBooking.markForEnable;
          _this3.form.bookingDateList = data.bookingDateList || [];
          _this3.form.diningDateList = data.diningDateList || [];
          _this3.form.checkedGoodsList = data.comboGoodsList || [];
        }
      });
    },
    submitForm: function submitForm() {
      var _this4 = this;
      // 如果不是编辑模式，使用选中的门店
      if (!this.isEditMode) {
        this.form.storeIds = this.checkedLeafKeys;
        if (this.checkedLeafKeys.length === 0) {
          this.$message.warning('请至少选择一个门店');
          return;
        }
      } else {
        this.form.storeIds = this.bookingList.map(function (item) {
          return item.storeId || item.id;
        });
      }

      // 提交表单
      if (this.fnId) {
        // 编辑
        var editData = _objectSpread(_objectSpread({}, this.form), {}, {
          fnId: this.fnId
        });
        (0, _booking.bookingEdit)(editData).then(function (res) {
          _this4.$message.success(res.message);
          _this4.loading = false;
          _this4.$emit('success');
        }, function () {
          _this4.loading = false;
        });
      } else {
        (0, _booking.bookingSave)(this.form).then(function (res) {
          _this4.$message.success(res.message);
          _this4.loading = false;
          _this4.$emit('success');
        }, function () {
          _this4.loading = false;
        });
      }
    },
    addGoods: function addGoods() {
      var exist = false;
      if (this.checkedGoods && this.checkedGoods.goodsFnId) {
        for (var i = 0; i < this.form.checkedGoodsList.length; i++) {
          var goods = this.form.checkedGoodsList[i];
          if (this.checkedGoods.goodsFnId === goods.goodsFnId && this.checkedGoods.unitFnId === goods.unitFnId) {
            exist = true;
            break;
          }
        }
        if (!exist) {
          this.form.checkedGoodsList.push(this.checkedGoods);
        }
        this.checkedGoods = {};
      }
    },
    removeGoods: function removeGoods(row) {
      var index = -1;
      for (var i = 0; i < this.form.checkedGoodsList.length; i++) {
        var goods = this.form.checkedGoodsList[i];
        if (row.goodsFnId === goods.goodsFnId && row.unitFnId === goods.unitFnId) {
          index = i;
          break;
        }
      }
      if (index !== -1) {
        this.form.checkedGoodsList.splice(index, 1);
      }
    },
    searchGoods: function searchGoods(query) {
      var _this5 = this;
      this.searchGoodsLoading = true;
      (0, _goods_activity_combo.queryComboGoodsSearch)({
        keywords: query
      }).then(function (res) {
        var data = res.data;
        if (data) {
          _this5.goodsList = data.goodsList || [];
          _this5.searchGoodsLoading = false;
        }
      }, function () {
        _this5.searchGoodsLoading = false;
      });
    },
    goBack: function goBack() {
      this.$emit('success');
    },
    // 处理门店选择变化
    handleStoreCheck: function handleStoreCheck(data, checked) {
      var _this6 = this;
      // 如果正在初始化，跳过处理
      if (this.isInitializing) return;
      if (checked) {
        // 拦截非叶子节点选择
        if (data.children && data.children.length > 0) {
          // 获取data.children的所有id
          data.children.forEach(function (item) {
            if (!_this6.checkedLeafKeys.includes(item.id)) {
              _this6.checkedLeafKeys.push(item.id);
              // 添加到已选择门店列表
              if (!_this6.selectedStores.some(function (store) {
                return store.storeId === item.id;
              })) {
                // 尝试从原始bookingList中获取完整信息，如果找不到则使用树形数据
                var originalStore = _this6.bookingList.find(function (b) {
                  return b.storeId === item.id || b.id === item.id;
                });
                if (originalStore) {
                  _this6.selectedStores.push(_objectSpread({}, originalStore));
                } else {
                  _this6.selectedStores.push({
                    storeId: item.id,
                    storeName: item.label,
                    storeAddress: item.address || ''
                  });
                }
              }
            }
          });
        } else {
          // 直接检查数组是否包含该元素
          if (!this.checkedLeafKeys.includes(data.id)) {
            this.checkedLeafKeys.push(data.id);
            // 添加到已选择门店列表
            if (!this.selectedStores.some(function (store) {
              return store.storeId === data.id;
            })) {
              // 尝试从原始bookingList中获取完整信息，如果找不到则使用树形数据
              var originalStore = this.bookingList.find(function (b) {
                return b.storeId === data.id || b.id === data.id;
              });
              if (originalStore) {
                this.selectedStores.push(_objectSpread({}, originalStore));
              } else {
                this.selectedStores.push({
                  storeId: data.id,
                  storeName: data.label,
                  storeAddress: data.address || ''
                });
              }
            }
          }
        }
      } else {
        // 如果是父节点，需要移除其所有子节点
        if (data.children && data.children.length > 0) {
          // 获取data.children的所有id
          data.children.forEach(function (item) {
            _this6.checkedLeafKeys = _this6.checkedLeafKeys.filter(function (id) {
              return id !== item.id;
            });
            _this6.selectedStores = _this6.selectedStores.filter(function (store) {
              return store.storeId !== item.id;
            });
          });
        } else {
          // 直接移除当前节点
          this.checkedLeafKeys = this.checkedLeafKeys.filter(function (id) {
            return id !== data.id;
          });
          this.selectedStores = this.selectedStores.filter(function (store) {
            return store.storeId !== data.id;
          });
        }
      }
    },
    // 选择全部门店（具有切换功能）
    selectAllStores: function selectAllStores() {
      // 设置操作标志，避免触发handleStoreCheck
      this.isInitializing = true;

      // 获取所有叶子节点的key
      var _getAllLeafKeys = function getAllLeafKeys(nodes) {
        var keys = [];
        nodes.forEach(function (node) {
          if (node.children && node.children.length > 0) {
            keys = keys.concat(_getAllLeafKeys(node.children));
          } else {
            keys.push(node.id);
          }
        });
        return keys;
      };
      var allLeafKeys = _getAllLeafKeys(this.storeTreeData);

      // 检查当前是否已经全选
      if (this.isAllSelected) {
        // 如果已经全选，则取消全选
        this.$refs.storeTree.setCheckedKeys([]);
        this.checkedLeafKeys = [];
        this.selectedStores = [];
      } else {
        // 如果未全选，则全选
        this.$refs.storeTree.setCheckedKeys(allLeafKeys);

        // 获取所有叶子节点（门店）信息
        var _getAllLeafNodes = function getAllLeafNodes(nodes) {
          var leafNodes = [];
          nodes.forEach(function (node) {
            if (node.children && node.children.length > 0) {
              leafNodes = leafNodes.concat(_getAllLeafNodes(node.children));
            } else {
              leafNodes.push({
                storeId: node.id,
                storeName: node.label,
                storeAddress: node.address || ''
              });
            }
          });
          return leafNodes;
        };

        // 更新选中的门店
        this.checkedLeafKeys = allLeafKeys;
        this.selectedStores = _getAllLeafNodes(this.storeTreeData);
      }

      // 操作完成后，取消操作标志
      this.isInitializing = false;
    },
    // 过滤节点
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    }
  }
};